import React, { Component } from "react";
import { Link } from "react-router-dom";

import data from "../../../../data/jobs.json";

class Carees_SiteContent extends Component {
  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div
            className="themesflat-carousel-box data-effect clearfix"
            data-gap={0}
            data-column={1}
            data-column2={1}
            data-column3={1}
            data-auto="true"
          >
            <div className="owl-carousel owl-theme">
              <div className="themesflat-gallery style-1 clearfix">
                <div className="gallery-item">
                  <div className="inner">
                    <div className="thumb">
                      <img
                        src="../assets/img/about/carees_header_img_01.jpg"
                        alt="CityX karijere"
                      />
                      <div className="text-wrap">
                        <span>Postani dio </span>
                        <h5 className="heading">CityX dream team-a!</h5>
                        <span>Čekamo te!</span>
                        <Link
                          to="/about/carees-job-application"
                          onClick={() => {
                            window.location.href =
                              "/about/carees-job-application";
                          }}
                          className="themesflat-button bg-accent"
                        >
                          POŠALJI ZAHTJEV
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="themesflat-gallery style-1 clearfix">
                <div className="gallery-item">
                  <div className="inner">
                    <div className="thumb">
                      <img
                        src="../assets/img/about/carees_header_img_02.jpg"
                        alt="CityX karijere"
                      />
                      <div className="text-wrap">
                        <span>Postani dio </span>
                        <h5 className="heading">CityX dream team-a!</h5>
                        <span>Čekamo te!</span>
                        <Link
                          to="/about/carees-job-application"
                          onClick={() => {
                            window.location.href =
                              "/about/carees-job-application";
                          }}
                          className="themesflat-button bg-accent"
                        >
                          POŠALJI ZAHTJEV
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={29}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="themesflat-headings style-2 clearfix">
            <h2 className="heading">OTVORENE POZICIJE</h2>
            <div className="sep has-width w80 accent-bg clearfix" />
            <p className="sub-heading font-size-16 line-height-28 text-666 margin-top-27 letter-spacing-01">
              City<b>X</b> je mlad startup unutar kojeg nastaju vrlo ambiciozni
              projekti. Okruženje je dinamično, ambicioznog i jako motiviranog
              tima. Organizirani smo kroz nekoliko odjela, koristimo agilne
              metode rada, a što je najbitnije razvijamo vlastite prizvode.
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={22}
            data-mobile={22}
            data-smobile={22}
          />
          <div className="themesflat-accordions style-4 has-icon icon-right iconstyle-1 clearfix">
            {data.jobs.map((job, index) => (
              <div className={`accordion-item ${index === 0 ? "active" : ""}`}>
                <h3 className="accordion-heading">
                  <span className="inner">{job.title}</span>
                </h3>
                <div className="accordion-content clearfix">
                  <div className="themesflat-row clearfix">
                    <div className="span_1_of_12">
                      <div
                        className="themesflat-content-box clearfix"
                        data-margin="0 22px 0 0px"
                        data-mobilemargin="0 22px 0 0px"
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: job.description }}
                        />
                        <div
                          className="themesflat-spacer clearfix"
                          data-desktop={10}
                          data-mobile={10}
                          data-smobile={10}
                        />
                      </div>
                    </div>
                    <div
                      className="themesflat-spacer clearfix"
                      data-desktop={20}
                      data-mobile={20}
                      data-smobile={20}
                    />
                    <div className="span_1_of_6">
                      <div>
                        <h6 className="name">Što nudimo:</h6>
                        {job.whatWeOffer.map((offer) => (
                          <>
                            <div className="themesflat-list has-icon style-2 icon-left clearfix">
                              <div className="inner">
                                <span className="item">
                                  <span className="icon">
                                    <i className="fa fa-check" />
                                  </span>
                                  <span className="text">{offer}</span>
                                </span>
                              </div>
                            </div>
                            <div
                              className="themesflat-spacer clearfix"
                              data-desktop={10}
                              data-mobile={10}
                              data-smobile={10}
                            />
                          </>
                        ))}
                      </div>
                    </div>
                    <div className="span_1_of_6">
                      <div
                        className="themesflat-spacer clearfix"
                        data-desktop={0}
                        data-mobile={0}
                        data-smobile={35}
                      />
                      <div
                        className="themesflat-content-box clearfix"
                        data-margin="0 12px 0 0px"
                        data-mobilemargin="0 0 0 0"
                      >
                        <h6 className="name">Što očekujemo</h6>
                        {job.whatWeExpect.map((expect) => (
                          <>
                            <div className="themesflat-list has-icon style-2 icon-left align-top clearfix">
                              <div className="inner">
                                <span className="item">
                                  <span className="icon">
                                    <i className="fa fa-check" />
                                  </span>
                                  <span className="text">{expect}</span>
                                </span>
                              </div>
                            </div>
                            <div
                              className="themesflat-spacer clearfix"
                              data-desktop={10}
                              data-mobile={10}
                              data-smobile={10}
                            />
                          </>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div
                    className="themesflat-spacer clearfix"
                    data-desktop={20}
                    data-mobile={20}
                    data-smobile={20}
                  />
                  <div className="span_1_of_6">
                    <a href="/about/carees-job-application">
                      <button
                        type="submit"
                        className="submit"
                        title="Search"
                        style={{ backgroundColor: "#5f88b9" }}
                      >
                        PRIJAVI SE!
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={78}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default Carees_SiteContent;
